var SCM = SCM || {};

(function (scm) {

    var config = {
        enabled: false,
        cookieName: 'osano_consentmanager_uuid',
        hashLength: 37
    };
    
    function getCookie(name) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    /**
     * Hash string to alphanumeric PPID.
     * Algorithm provided by ACS for Osano UUID → GAM PPID conversion.
     * @param {string} str - Input string (UUID)
     * @param {number} len - Desired output length
     * @returns {string|null} Hashed alphanumeric string or null
     */
    function stringToHexHash(str, len) {
        if (!str) {
            return null;
        }

        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        var hex = hash.toString(16);
        var alphanumeric = hex.replace(/[^0-9a-zA-Z]/gi, '');
        while (alphanumeric.length < len) {
            alphanumeric = '0' + alphanumeric;
        }
        return alphanumeric.substr(0, len);
    }

    /**
     * Check if marketing consent is granted via Osano
     * @returns {boolean} True if consent granted, false otherwise
     */
    function hasMarketingConsent() {
        if (!window.Osano || !window.Osano.cm) {
            return false;
        }

        try {
            var consent = window.Osano.cm.getConsent();
            return consent && consent['MARKETING'] !== 'DENY';
        } catch (e) {
            return false;
        }
    }
    
    function getOsanoUUID() {
        return getCookie(config.cookieName);
    }
    
    function applySettings() {
        var settings = scm.settings;
        if (settings) {
            config.enabled = settings.enabled || false;
            config.cookieName = settings.cookieName || config.cookieName;
            config.hashLength = settings.hashLength || config.hashLength;
        }
    }

    // Settings are set by an inline script in GoogleTagServices.cshtml
    // which renders before this bundled JS loads. If load order changes,
    // applySettings() will silently use defaults (enabled: false).
    applySettings();
    
    scm.SetPpidIfConsented = function () {
        if (!config.enabled) {
            return false;
        }

        if (!hasMarketingConsent()) {
            return false;
        }

        var uuid = getOsanoUUID();
        if (!uuid) {
            return false;
        }

        var ppid = stringToHexHash(uuid, config.hashLength);
        if (!ppid) {
            return false;
        }

        if (typeof googletag !== 'undefined' && googletag.pubads) {
            googletag.pubads().setPublisherProvidedId(ppid);
            return true;
        }

        return false;
    };

})(SCM.PpidFrequencyCapping = SCM.PpidFrequencyCapping || {});
